import { PieChartRenderer } from '@leverege/ui-attributes-graphs';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import React from 'react';
import NoChartDataView from "../views/NoChartDataView.js";
import ChartErrorView from "../views/ChartErrorView.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon,
  exists
} = I18N.ns('molten.dataViewers.history.HistoryPieChartView');
export default function HistoryPieChartView(props) {
  const {
    settings,
    paginator,
    objectType,
    loadingPages,
    error
  } = props;
  let noDataMessage;
  if (error) {
    noDataMessage = Config.get(HistoryPieChartView.CLIENT, 'errorMessage', ChartErrorView);
  } else {
    noDataMessage = Config.get(HistoryPieChartView.CLIENT, 'noChartDataMessage', NoChartDataView);
  }
  if (noDataMessage != null && typeof noDataMessage !== 'string') {
    // assume its a component class/function
    const Clazz = noDataMessage;
    noDataMessage = /*#__PURE__*/_jsx(Clazz, {
      ...props,
      client: HistoryPieChartView.CLIENT,
      t: t,
      tIcon: tIcon,
      exists: exists
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: 'relative',
      height: '100%'
    },
    children: [loadingPages && /*#__PURE__*/_jsx("i", {
      style: {
        position: 'absolute',
        top: 10,
        right: 10,
        color: 'var( --color-brand500 )'
      },
      className: "fa fa-spin fa-circle-o-notch"
    }), /*#__PURE__*/_jsx(PieChartRenderer, {
      loading: paginator.loading,
      noDataMessage: noDataMessage,
      model: settings,
      objectType: objectType,
      data: paginator.pageItems
    })]
  });
}
HistoryPieChartView.CLIENT = 'HistoryPieChartDataViewer';